import React from 'react';
import ContentLoader from 'react-content-loader'

const SelectBoxListLoader = (props) => {
    return (
        <div className="row col-12 px-5">
        <ContentLoader
            speed={2}
            width={500}
            height={50}
            viewBox="0 0 500 50"
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
            {...props}
        >
            <rect x="293" y="0" rx="0" ry="0" width="0" height="10" />
            <rect x="13" y="208" rx="0" ry="0" width="8" height="4" />
            <rect x="98" y="94" rx="0" ry="0" width="7" height="4" />
            <circle cx="403" cy="537" r="91" />
            <rect x="23" y="37" rx="0" ry="0" width="10" height="1" />
            <rect x="8" y="15" rx="0" ry="0" width="33" height="32" />
            <rect x="66" y="16" rx="0" ry="0" width="460" height="11" />
            <rect x="67" y="38" rx="0" ry="0" width="455" height="8" />
        </ContentLoader>
        </div>
    );
};

export default SelectBoxListLoader;